export const bluedot = require('./bluedot.png')

/// Directional map Marker arrows.  0 is North; each following is rotated 10 degress.  360/10 = 36 icons.

export const locationArrowBlue = require('./location-arrow-blue.png')
export const locationArrowGreen = require('./location-arrow-green.png')
export const locationArrowAmber = require('./location-arrow-amber.png')
export const locationArrowRed = require('./location-arrow-red.png')

/// Small green, yellow, red geofence edge-coordinate circles.
export const geofenceEventEdgeCircleDwell = require('./geofence-event-edge-circle-dwell.png')
export const geofenceEventEdgeCircleEnter = require('./geofence-event-edge-circle-enter.png')
export const geofenceEventEdgeCircleExit = require('./geofence-event-edge-circle-exit.png')
